import { render, staticRenderFns } from "./auditgoods.vue?vue&type=template&id=77597518&scoped=true"
import script from "./auditgoods.vue?vue&type=script&lang=js"
export * from "./auditgoods.vue?vue&type=script&lang=js"
import style0 from "./auditgoods.vue?vue&type=style&index=0&id=77597518&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77597518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77597518')) {
      api.createRecord('77597518', component.options)
    } else {
      api.reload('77597518', component.options)
    }
    module.hot.accept("./auditgoods.vue?vue&type=template&id=77597518&scoped=true", function () {
      api.rerender('77597518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auditcenter/auditgoods.vue"
export default component.exports